import React, { Component } from 'react'
import { Flex } from 'hljd'
import style from './style.module.less'
import { goShopProductPage, getProTitle, getMerchantInfo } from '@util'
import { Button } from 'hljd'
import { getDates } from '../util'

export default class extends Component {
  constructor(props) {
    super(props)
    this.proTitle = getProTitle()
  }

  getExpireDate = () => {
    const { pro_date } = getMerchantInfo()
    const end_time = (pro_date || '').split(' ')[0]
    const isWillExpire = getDates(pro_date)
    const {
      product: { tips }
    } = this.props
    return (
      <>
        <div>
          {tips && <div className={style.des}>{tips}</div>}
          <span style={{ color: '#448afc', marginRight: 10 }}>
            已开通 有效期至{end_time}
          </span>
          {isWillExpire && <span style={{ color: '#ff801a' }}>(即将过期)</span>}
        </div>

        {isWillExpire && (
          <Button
            style={{ marginTop: 10 }}
            type="primary"
            onClick={() => goShopProductPage()}
          >
            续费{this.proTitle}免费使用
          </Button>
        )}
      </>
    )
  }

  render() {
    const {
      product: { logo, title, des, hasAuth },
      renderBtn
    } = this.props
    return (
      <Flex className={style.header}>
        <img src={logo} className={style.logo} />

        <div className={style.info}>
          <div className={style.title}>{title}</div>
          <div className={style.des}>{des}</div>

          <div>
            {hasAuth ? (
              renderBtn ? (
                renderBtn()
              ) : (
                this.getExpireDate()
              )
            ) : (
              <Button type="primary" onClick={() => goShopProductPage()}>
                开通{this.proTitle}免费使用
              </Button>
            )}
          </div>
        </div>
      </Flex>
    )
  }
}
